import { globalFields } from './global-fields';

const incidentTags = {
  fields: [
    globalFields.incident.incidentId,
    globalFields.incident.tags,
    {
      name: 'tagLabels',
      label: 'Tags',
      validators: {},
    },
  ],
  customFields: [],
};

const primaryInformation = {
  fields: [
    {
      name: 'incidentTypes',
      label: 'Incident Type',
      validators: {},
    },
    {
      name: 'assignedNumbers',
      label: 'Assigned Numbers',
      array: [
        {
          name: 'assignedNumberTypeId',
          label: 'Type',
          validators: {
            required: true,
          },
        },
        {
          name: 'assignedNumberValue',
          label: 'Value',
          validators: {
            required: true,
          },
        },
      ],
    },
    {
      name: 'primaryAgencyOrganizationId',
      label: 'Primary Agency',
      validators: {},
    },
    {
      name: 'divisionId',
      label: 'Division',
      validators: {},
    },
    {
      name: 'sourceId',
      label: 'Source',
      validators: {},
    },
    {
      name: 'statusId',
      label: 'Status',
      validators: {},
    },
    {
      name: 'dispositionId',
      label: 'Disposition',
      validators: {},
    },
    {
      name: 'weatherId',
      label: 'Weather',
      validators: {},
    },
    {
      name: 'occurredOn',
      label: 'Report Date',
      validators: {}
    },
    {
      name: 'clearedOn',
      label: 'Clear Date',
      validators: {}
    },
    {
      name: 'clearanceCodeId',
      label: 'UCR Clear Code',
      validators: {}
    },
    {
      name: 'ucrCodeId',
      label: 'UCR Code',
      validators: {}
    },
    {
      name: 'counts',
      label: 'Incident Count',
      validators: {}
    },
    {
      name: 'arsonValue',
      label: 'Arson Value',
      validators: {}
    },
    {
      name: 'humanTraffickingId',
      label: 'Human Trafficking',
      validators: {}
    },
    {
      name: 'humanTrafficCount',
      label: 'Human Traffic Count',
      validators: {}
    },
    {
      name: 'exceptionalClearanceId',
      label: 'Exceptional Clear Type',
      validators: {}
    },
    {
      name: 'exceptionalClearanceDate',
      label: 'Exceptional Clear Date',
      validators: {}
    },
    {
      name: 'submittedDate',
      label: 'Submitted Date',
      validators: {}
    },
    {
      name: 'isReadyToSubmit',
      label: 'Ready To Submit',
      validators: {}
    },
    {
      name: 'isReadyToReSubmit',
      label: 'Ready To Re-Submit',
      validators: {}
    },
    {
      name: 'isUnfounded',
      label: 'Unfounded',
      validators: {}
    },
    {
      name: 'officerRankId',
      label: 'Officer Rank',
      validators: {}
    },
    {
      name: 'officerFullName',
      label: 'Officer Full Name',
      validators: {}
    },
    {
      name: 'statePoliceStationId',
      label: 'State Police Station',
      validators: {}
    },
    {
      name: 'isStreetGang',
      label: 'Street Gang',
      validators: {}
    },
    {
      name: 'isOrganizedGroup',
      label: 'Organized Group',
      validators: {}
    },
    {
      name: 'isApproved',
      label: 'Approved',
      validators: {}
    },
    {
      name: 'nibrsReviewApprovedOn',
      label: 'Approved On',
      validators: {}
    },
    {
      name: 'nibrsReviewEmployeeId',
      label: 'Approved By',
      validators: {}
    },
    {
      name: 'isNIBRSReviewerSupervisor',
      label: 'Supervisor',
      validators: {}
    },
    {
      name: 'locationCodeId',
      label: 'Location Code',
      validators: {}
    },
    {
      name: 'stateDivisionPrecinctIdentifier',
      label: 'Station/Division/Precinct Identifier',
      validators: { maxLength: 6 }
    },
    {
      name: 'timeWindowTypeId',
      label: 'Time Window Type',
      validators: {}
    },
    {
      name: 'biasCrimeTypeIds',
      label: 'Bias Crime Type',
      validators: {}
    }
  ],
  customFields: [],
};

const persons = {
  fields: [
    {
      name: 'linkDate',
      label: 'Link Date',
      validators: {},
    },
    {
      name: 'involvement',
      label: 'Involvement',
      validators: { required: true },
    },
    {
      name: 'ucrInvolvementCodes',
      label: 'UCR Involvement Codes',
      validators: {},
    },
    {
      name: 'comment',
      label: 'Comment',
      validators: {},
    },
    {
      name: 'isVictim',
      label: 'NIBRS Victim',
    },
    {
      name: 'victimTypeId',
      label: 'Victim Type',
    },
    {
      name: 'personAndIncidentReportId',
      label: 'Person',
      validators: {}
    },
    {
      name: 'organizationAndIncidentReportId',
      label: 'Organization',
      validators: {}
    },
    {
      name: 'incidentReportNibrsOffenseIds',
      label: 'Linked NIBRS Offenses',
      validators: {}
    },
    {
      name: 'officerActivityTypeId',
      label: 'Officer Activity Type',
      validators: {}
    },
    {
      name: 'officerAssignmentTypeId',
      label: 'Officer Assignment Type',
      validators: {}
    },
    {
      name: 'officerJurisdictionOri',
      label: 'Officer Jurisdiction ORI',
      validators: {}
    },
    {
      name: 'assaultCircumstancesTypeIds',
      label: 'Assault Circumstances',
      validators: {}
    },
    {
      name: 'homicideTypeId',
      label: 'Homicide Type',
      validators: {}
    },
    {
      name: 'victimInjuryTypeIds',
      label: 'Victim Injuries',
      validators: {}
    },
    {
      name: 'domesticViolenceId',
      label: 'Domestic Violence',
      validators: {}
    },
    {
      name: 'victimResidencyStatusId',
      label: 'Resident Status',
      validators: {}
    },
    {
      name: 'injuryLevelId',
      label: 'Injury Level',
      validators: {}
    },
    {
      name: 'medicalTypeId',
      label: 'Medical Treatment',
      validators: {}
    },
    {
      name: 'immigrationStatusId',
      label: 'Immigration Status',
      validators: {}
    },
    {
      name: 'isOffender',
      label: 'NIBRS Offender',
    },
    {
      name: 'offenderPersonAndIncidentReportId',
      label: 'Person',
    },
    {
      name: 'offenderIncidentReportNibrsOffenseIds',
      label: 'Linked NIBRS Offenses',
      validators: {}
    },
    {
      name: 'offenderNibrsVictims',
      label: 'Associated Victims',
      array: [
        {
          name: 'nibrsVictimId',
          label: 'Victim',
        },
        {
          name: 'nibrsRelationshipId',
          label: 'Relationship Type',
        }
      ]
    },
    {
      name: 'offenderDomesticViolenceId',
      label: 'Domestic Violence',
      validators: {}
    },
    {
      name: 'offenderNibrsAssaultFirearmOffenseCodeIds',
      label: 'Assault Firearm Offenses',
      validators: {}
    },
    {
      name: 'offenderConditionId',
      label: 'Offender Condition',
      validators: {}
    },
    {
      name: 'offenderImmigrationStatusId',
      label: 'Immigration Status',
      validators: {}
    },
  ],
  customFields: []
}

const organizations = {
  fields: [
    {
      name: 'linkDate',
      label: 'Link Date',
      validators: {},
    },
    {
      name: 'linkTypeIds',
      label: 'Involvement Type',
      validators: {},
    },
    {
      name: 'useIncidentLocation',
      label: 'Use Incident Location as Address',
      validators: {},
    },
    {
      name: 'incidentLocationId',
      label: 'Address',
      validators: {},
    },
    {
      name: 'organizationAddressTypeId',
      label: 'Address Type',
      validators: {},
    },
    {
      name: 'comment',
      label: 'Comment',
      validators: {},
    },
    {
      name: 'isVictim',
      label: 'NIBRS Victim',
    },
    {
      name: 'victimTypeId',
      label: 'Victim Type',
      validators: { required: true }
    },
    {
      name: 'organizationAndIncidentReportId',
      label: 'Organization',
      validators: {}
    },
    {
      name: 'incidentReportNibrsOffenseIds',
      label: 'Linked NIBRS Offenses',
      validators: {}
    },
  ],
  customFields: []
}
const assignments = {
  fields: [
    {
      name: 'assignments',
      label: 'Assignments',
      array: [
        {
          name: 'creatingOfficerId',
          label: 'Officer Creating',
          validators: {
            required: true
          },
        },
        {
          name: 'submittedOn',
          label: 'Date Assigned',
          validators: {},
        },
        {
          name: 'assignedOfficerId',
          label: 'Assigned To',
          validators: {
            required: true
          },
        },
        {
          name: 'assignedOfficerDivisionId',
          label: 'Division',
          validators: {},
        },
        {
          name: 'dueOn',
          label: 'Due Date',
          validators: {},
        },
        {
          name: 'description',
          label: 'Comment',
          validators: {},
        },
        {
          name: 'isAcknowledged',
          label: 'Acknowledged',
          validators: {},
        },
        {
          name: 'acknowledgedOn',
          label: 'Acknowledged (Date)',
          validators: {},
        },
        {
          name: 'isCompleted',
          label: 'Completed',
          validators: {},
        },
        {
          name: 'completedOn',
          label: 'Completed (Date)',
          validators: {},
        },
        {
          name: 'followUpStatusId',
          label: 'Follow Up Status',
          validators: {},
        },
        {
          name: 'id',
          label: 'Id',
          validators: {},
        },
        {
          name: 'assignmentTypeId',
          label: 'Assignment Type',
          validators: {
            required: true
          },
        },
      ],
    },
  ],
  customFields: [],
};

const chargings = {
  fields: [
    {
      name: 'linkDate',
      label: 'Link Date',
      validators: {}
    },
    {
      name: 'linkTypeIds',
      label: 'Link Type Ids',
      validators: {}
    },
    {
      name: 'arrestReportId',
      label: 'Arrest Report',
      validators: {}
    },
    {
      name: 'nibrsTransactionNumber',
      label: 'Transaction Number',
      validators: {}
    },
    {
      name: 'nibrsArrestTypeId',
      label: 'Arrest Type',
      validators: {}
    },
    {
      name: 'nibrsArrestStatusId',
      label: 'Arrest Status',
      validators: {}
    },
    {
      name: 'nibrsImmigrationStatusId',
      label: 'Immigration Status',
      validators: {}
    },
    {
      name: 'nibrsJuvenileDispositionTypeId',
      label: 'Juvenile Disposition',
      validators: {}
    },
    {
      name: 'nibrsArresteeWeaponIds',
      label: 'Arrestee Weapon(s)',
      validators: {}
    },
    {
      name: 'nibrsAutomaticWeapons_0',
      label: 'Automatic Weapon',
      validators: {}
    },
    {
      name: 'nibrsAutomaticWeapons_1',
      label: 'Automatic Weapon',
      validators: {}
    },
    {
      name: 'nibrsMultipleArresteeTypeId',
      label: 'Multiple Arrestee',
      validators: {}
    },
    {
      name: 'nibrsViolationId',
      label: 'Primary NIBRS Offense',
      validators: {}
    },
    {
      name: 'incidentReportArrestUCRDetailId',
      label: 'Incident Report Arrest UCR Detail',
      validators: {}
    },
    {
      name: 'isUcrArrest',
      label: 'UCR Arrest',
      validators: {}
    },
    {
      name: 'ucrCodeId',
      label: 'UCR Code',
      validators: {}
    },
    {
      name: 'ucrJuvenileDispositionId',
      label: 'UCR Juvenile Disposition',
      validators: {}
    },
    {
      name: 'ucrPartCOptionId',
      label: 'Part C Option',
      validators: {}
    },
    {
      name: 'ucrVerdictId',
      label: 'Verdict',
      validators: {}
    },
    {
      name: 'sentenceDate',
      label: 'Sentence Date',
      validators: {}
    },
    {
      name: 'comment',
      label: 'Comment',
      validators: {}
    },
  ],
  customFields: [],
}

const professionalStandards = {
  fields: [
    {
      name: 'stateLawEnforcementAccreditations',
      label: 'State Standards',
      validators: {}
    },
    {
      name: 'commissionLawEnforcementAccreditations',
      label: 'CALEA Standards',
      validators: {}
    },
  ],
  customFields: [],
};

const dates = {
  fields: [
    {
      name: 'occurredFrom',
      label: 'Occurred Start',
      validators: {},
    },
    {
      name: 'occurredTo',
      label: 'Occurred End',
      validators: {},
    },
    {
      name: 'receivedOn',
      label: 'Received On',
      validators: {},
    },
    {
      name: 'dispatchedOn',
      label: 'Dispatched On',
      validators: {},
    },
    {
      name: 'arrivedOn',
      label: 'Arrived On',
      validators: {},
    },
    {
      name: 'clearedOn',
      label: 'Cleared On',
      validators: {},
    },
  ],
  customFields: [],
};

const modusOperandis = {
  fields: [
    {
      name: 'modusOperandis',
      label: 'MO',
      array: [
        {
          name: 'modusOperandiGroup',
          label: 'MO Group',
          array: [
            {
              name: 'modusOperandiTypeId',
              label: 'Type',
              validators: {
                required: true,
              },
            },
            {
              name: 'modusOperandiCodeId',
              label: 'Code',
              validators: {},
            },
            {
              name: 'modusOperandiComment',
              label: 'Comment',
              validators: {},
            },
          ],
        },
      ],
    },
  ],
  customFields: [],
};

const location = {
  fields: [
    {
      name: 'involvement',
      label: 'Involvement',
      validators: {},
    },
    {
      name: 'isPrimary',
      label: 'Primary',
      validators: {},
    },
    {
      name: 'incidentAndAddressId',
      label: 'incidentAndAddressId',
      validators: {},
    },
  ],
  customFields: [],
};

const incidentReview = {
  fields: [
    globalFields.incident.level1Reviewers,
    globalFields.incident.level2Reviewers,
    globalFields.incident.level3Reviewers,
    {
      name: 'comment',
      label: 'Comment',
      validators: {
        required: true,
    },
    },
    {
      name: 'selectedNarratives',
      label: 'Narratives',
      validators: {},
    },
    globalFields.incident.level1GroupReviewers,
    globalFields.incident.level2GroupReviewers,
    globalFields.incident.level3GroupReviewers
  ],
  customFields: []
}

const incidentReviewers = {
  fields: [
    globalFields.incident.level1Reviewers,
    globalFields.incident.level2Reviewers,
    globalFields.incident.level3Reviewers,
    globalFields.incident.level4Reviewers,
    globalFields.incident.level1GroupReviewers,
    globalFields.incident.level2GroupReviewers,
    globalFields.incident.level3GroupReviewers,
    globalFields.incident.level4GroupReviewers,
  ],
  customFields: []
}

// Unit and Officer records
const supervisor = {
  fields: [
    {
      name: 'id',
      label: 'Supervisor',
      validators: {},
    },
  ],
  customFields: [],
};


const unitOfficers = {
    fields: [
        {
            name: 'sequence',
            label: 'Sequence',
            validators: {}
        },
        {
            name: 'agency',
            label: 'Agency',
            validators: {}
        },
        {
            name: 'unit',
            label: 'Unit',
            validators: {}
        },
        {
            name: 'vehicle',
            label: 'Vehicle',
            validators: {}
        },
        {
            name: 'employeeId',
            label: 'Officer',
            validators: {}
        },
        {
            name: 'isPrimary',
            label: 'Primary',
            validators: {}
        },
        {
            name: 'divisionId',
            label: 'Division',
            validators: {}
        },
        {
            name: 'assignment',
            label: 'Assignment',
            validators: {}
        },
        {
            name: 'dispatched',
            label: 'Dispatched',
            validators: {}
        },
        {
            name: 'cleared',
            label: 'Cleared',
            validators: {}
        },
        {
            name: 'arrived',
            label: 'Arrived',
            validators: {}
        },
        {
          name: 'isSupervisor',
          label: 'Supervisor',
          validators: {}
      },
    ],
    customFields: []
};

const personAssociation = {
  fields: [
    globalFields.person.firstName,
    globalFields.person.middleName,
    globalFields.person.lastName,
    globalFields.person.dateOfBirth,
    globalFields.person.age,
    globalFields.address.primaryAddress,
    globalFields.person.sex,
    globalFields.person.race,
    globalFields.person.ethnicity,
  ],
  customFields: [],
};

const nibrsPrimaryInformation = {
  fields: [
    {
      name: 'exceptionalClearanceId',
      label: 'Exceptional Clear Type',
      validators: {}
    },
    {
      name: 'exceptionalClearanceDate',
      label: 'Exceptional Clear Date',
      validators: {}
    },
    {
      name: 'submittedDate',
      label: 'Submitted Date',
      validators: {}
    },
    {
      name: 'isReadyToSubmit',
      label: 'Ready To Submit',
      validators: {}
    },
    {
      name: 'isReadyToReSubmit',
      label: 'Ready To Re-Submit',
      validators: {}
    },
    {
      name: 'isUnfounded',
      label: 'Unfounded',
      validators: {}
    },
    {
      name: 'officerRankId',
      label: 'Officer Rank',
      validators: {}
    },
    {
      name: 'officerFullName',
      label: 'Officer Full Name',
      validators: {}
    },
    {
      name: 'statePoliceStationId',
      label: 'State Police Station',
      validators: {}
    },
    {
      name: 'isStreetGang',
      label: 'Street Gang',
      validators: {}
    },
    {
      name: 'isOrganizedGroup',
      label: 'Organized Group',
      validators: {}
    },
    {
      name: 'nibrsReviewEmployeeId',
      label: 'Approved By',
      validators: {}
    },
    {
      name: 'isNIBRSReviewerSupervisor',
      label: 'Supervisor',
      validators: {}
    },
    {
      name: 'locationCodeId',
      label: 'Location Code',
      validators: {}
    },
    {
      name: 'stateDivisionPrecinctIdentifier',
      label: 'Station/Division/Precinct Identifier',
      validators: { maxLength: 6 }
    },
    {
      name: 'timeWindowTypeId',
      label: 'Time Window Type',
      validators: {}
    },
    {
      name: 'biasCrimeTypeIds',
      label: 'Bias Crime Type',
      validators: {}
    }
  ],
  customFields: []
}

const nibrsVictimPopoutForm = {
  fields: [
    {
      name: 'victimTypeId',
      label: 'Victim Type',
      validators: { required: true }
    },
    {
      name: 'personAndIncidentReportId',
      label: 'Person',
      validators: {}
    },
    {
      name: 'organizationAndIncidentReportId',
      label: 'Organization',
      validators: {}
    },
    {
      name: 'incidentReportNibrsOffenseIds',
      label: 'Linked NIBRS Offenses',
      validators: {}
    },
    {
      name: 'officerActivityTypeId',
      label: 'Officer Activity Type',
      validators: {}
    },
    {
      name: 'officerAssignmentTypeId',
      label: 'Officer Assignment Type',
      validators: {}
    },
    {
      name: 'officerJurisdictionOri',
      label: 'Officer Jurisdiction ORI',
      validators: {}
    },
    {
      name: 'assaultCircumstancesTypeIds',
      label: 'Assault Circumstances',
      validators: {}
    },
    {
      name: 'homicideTypeId',
      label: 'Homicide Type',
      validators: {}
    },
    {
      name: 'victimInjuryTypeIds',
      label: 'Victim Injuries',
      validators: {}
    },
    {
      name: 'domesticViolenceId',
      label: 'Domestic Violence',
      validators: {}
    },
    {
      name: 'victimResidencyStatusId',
      label: 'Resident Status',
      validators: {}
    },
    {
      name: 'injuryLevelId',
      label: 'Injury Level',
      validators: {}
    },
    {
      name: 'medicalTypeId',
      label: 'Medical Treatment',
      validators: {}
    },
    {
      name: 'immigrationStatusId',
      label: 'Immigration Status',
      validators: {}
    },
  ],
  customFields: []
}

const nibrsOffenderPopoutForm = {
  fields: [
    {
      name: 'personAndIncidentReportId',
      label: 'Person',
      validators: { required: true }
    },
    {
      name: 'incidentReportNibrsOffenseIds',
      label: 'Linked NIBRS Offenses',
      validators: {}
    },
    {
      name: 'nibrsVictims',
      label: 'Associated Victims',
      array: [
        {
          name: 'nibrsVictimId',
          label: 'Victim',
          validators: {required: true}
        },
        {
          name: 'nibrsRelationshipId',
          label: 'Relationship Type',
          validators: {}
        }
      ]
    },
    {
      name: 'domesticViolenceId',
      label: 'Domestic Violence',
      validators: {}
    },
    {
      name: 'nibrsAssaultFirearmOffenseCodeIds',
      label: 'Assault Firearm Offenses',
      validators: {}
    },
    {
      name: 'conditionId',
      label: 'Offender Condition',
      validators: {}
    },
    {
      name: 'immigrationStatusId',
      label: 'Immigration Status',
      validators: {}
    },
  ],
  customFields: []
}

const nibrsOffensePopoutForm = {
  fields: [
    {
      name: 'violationCodeId',
      label: 'NIBRS Offense Code',
      validators: { required: true }
    },
    {
      name: 'chargeCodeId',
      label: 'Local Code',
      validators: {}
    },
    {
      name: 'attemptedCompletedTypeId',
      label: 'Attempted/Completed',
      validators: { required: true }
    },
    {
      name: 'locationTypeId',
      label: 'Location Type',
      validators: { required: true }
    },
    {
      name: 'victimTypeId',
      label: 'Victim Type',
      validators: {}
    },
    {
      name: 'numberOfPremises',
      label: '# of Premises',
      validators: {}
    },
    {
      name: 'methodOfEntryTypeId',
      label: 'Method of Entry Type',
      validators: {}
    },
    {
      name: 'isCargoTheft',
      label: 'Cargo Theft',
      validators: {}
    },
    {
      name: 'suspectedUsingIds',
      label: 'Suspected Using',
      validators: { required: true }
    },
    {
      name: 'biasMotivationIds',
      label: 'Bias Motivations',
      validators: { required: true }
    },
    {
      name: 'criminalAndGangActivityIds',
      label: 'Criminal and Gang Activities',
      validators: {}
    },
    {
      name: 'weaponForceIds',
      label: 'Weapon/Force',
      validators: {}
    },
    //These fields get built out as part of an ngFor, not part of an array field though.  Probably a sleeker way to do this.
    {
      name: 'automaticWeapons_0',
      label: 'Automatic Weapon',
      validators: {}
    },
    {
      name: 'automaticWeapons_1',
      label: 'Automatic Weapon',
      validators: {}
    },
    {
      name: 'automaticWeapons_2',
      label: 'Automatic Weapon',
      validators: {}
    },
    {
      name: 'larcenyTypeId',
      label: 'Larceny Type',
      validators: {}
    },
    {
      name: 'assaultCircumstancesTypeIds',
      label: 'Assault Circumstances',
      validators: {}
    },
    {
      name: 'homicideTypeId',
      label: 'Homicide Type',
      validators: {}
    }
  ],
  customFields: []
}

const nibrsPropertyPopoutForm = {
  fields: [
    {
      name: 'propertyAndIncidentReportId',
      label: 'Property',
      validators: { required: true }
    },
    {
      name: 'propertyDescriptionId',
      label: 'Property Description',
      validators: {}
    },
    {
      name: 'nibrsOffenses',
      label: 'Associated NIBRS Offenses',
      array: [
        {
          name: 'violationId',
          label: 'NIBRS Offense',
          validators: { required: true }
        },
        {
          name: 'lossTypeId',
          label: 'Loss Type',
          validators: {}
        },
        {
          name: 'amount',
          label: 'Value of Property',
          validators: {}
        },
        {
          name: 'recoveredOn',
          label: 'Date Recovered',
          validators: {}
        }
      ]
    },
    {
      name: 'drugTypeId',
      label: 'Suspected Drug Type',
      validators: {}
    },
    {
      name: 'drugQuantity',
      label: 'Estimated Drug Quantity',
      validators: {}
    },
    {
      name: 'drugMeasurementId',
      label: 'Drug Measurement',
      validators: {}
    },
    {
      name: 'over3Drugs',
      label: 'Over 3 Drugs',
      validators: {}
    },
    {
      name: 'numberOfStolenVehicles',
      label: '# of Stolen Vehicles',
      validators: {}
    },
    {
      name: 'numberOfRecoveredVehicles',
      label: '# of Recovered Vehicles',
      validators: {}
    },
    {
      name: 'nibrsPropertyDamages',
      label: 'Property Damages',
      array: [
        {
          name: 'entryPointId',
          label: 'Entry Point',
          validators: { required: true }
        },
        {
          name: 'descriptionId',
          label: 'Description',
          validators: { required: true }
        },
        {
          name: 'damageAmount',
          label: 'Damage Amount',
          validators: { }
        }
      ]
    },
    {
      name: 'firearmMakeId',
      label: 'Firearm Make',
      validators: {}
    },
    {
      name: 'firearmModel',
      label: 'Firearm Model',
      validators: {}
    },
    {
      name: 'firearmCaliber',
      label: 'Firearm Caliber',
      validators: {}
    },
    {
      name: 'firearmSerialNumber',
      label: 'Firearm Serial #',
      validators: {}
    },
    {
      name: 'isCarjacked',
      label: 'Carjacked',
      validators: {}
    },
    {
      name: 'nibrsCarjackingCodeIds',
      label: 'Carjacking Code(s)',
      validators: {}
    },
    {
      name: 'ncicOffenseCodeId',
      label: 'NCIC Code',
      validators: {}
    },
    {
      name: 'drugDataSourceId',
      label: 'Source of Drug',
      validators: {}
    },
  ],
  customFields: []
}

const nibrsArresteePopoutForm = {
  fields: [
    {
      name: 'chargingAndIncidentReportId',
      label: 'Arrest Report',
      validators: { required: true }
    },
    {
      name: 'arrestTypeId',
      label: 'Type of Arrest',
      validators: {}
    },
    {
      name: 'multipleArresteeTypeId',
      label: 'Multiple Arrest',
      validators: {}
    },
    {
      name: 'juvenileDispositionTypeId',
      label: 'Juvenile Disposition',
      validators: {}
    },
    {
      name: 'arresteeWeaponIds',
      label: 'Weapon/Force',
      validators: {}
    },
    //These fields get built out as part of an ngFor, not part of an array field though.  Probably a sleeker way to do this.
    {
      name: 'automaticWeapons_0',
      label: 'Automatic Weapon',
      validators: {}
    },
    {
      name: 'automaticWeapons_1',
      label: 'Automatic Weapon',
      validators: {}
    },
    {
      name: 'violationId',
      label: 'Primary NIBRS Offense',
      validators: {}
    },
    {
      name: 'arrestStatusId',
      label: 'Arrest Status',
      validators: {}
    },
    {
      name: 'immigrationStatusId',
      label: 'Immigration Status',
      validators: {}
    },
  ],
  customFields: []
}

const ucrPersonsForm = {
  fields: [
    {
      name: 'personDetails',
      label: 'Person Details',
      array: [
        {
          name: 'personAndIncidentReportId',
          label: 'Associated Person',
          validators: { required: true }
        },
        {
          name: 'ucrInvolvementCodeId',
          label: 'UCR Involvement Code',
          validators: {}
        }
      ]
    }
  ],
  customFields: []
}

const ucrLeokaForm = {
  fields: [
    {
      name: 'leokaActivityTypeId',
      label: 'Activity Type',
      validators: {}
    },
    {
      name: 'leokaAssaultTimeTypeId',
      label: 'Time of Assault',
      validators: {}
    },
    {
      name: 'assaultsClearedCount',
      label: 'Assaults Cleared',
      validators: {}
    },
    {
      name: 'weaponDetails',
      label: 'Weapon Details',
      array: [
        {
          name: 'detailType',
          label: 'Type of Weapon',
          validators: { required: true }
        },
        {
          name: 'weaponCount',
          label: 'Total',
          validators: {}
        },
        {
          name: 'weaponInjuryCount',
          label: 'Injuries',
          validators: {}
        },
        {
          name: 'weaponNoInjuryCount',
          label: 'No Injuries',
          validators: {}
        }
      ]
    },
    {
      name: 'officerDetails',
      label: 'Officer Details',
      array: [
        {
          name: 'detailType',
          label: 'Type of Officer',
          validators: { required: true }
        },
        {
          name: 'officerAloneCount',
          label: 'Alone',
          validators: {}
        },
        {
          name: 'officerAssistedCount',
          label: 'Assisted',
          validators: {}
        }
      ]
    }
  ],
  customFields: []
}

const ucrHomicideForm = {
  fields: [
    {
      name: 'victimOffenderSituationId',
      label: 'Situation',
      validators: {}
    },
    {
      name: 'incidentDate',
      label: 'Homicide Date/Time',
      validators: {}
    },
    {
      name: 'description',
      label: 'Description',
      validators: {}
    },
    {
      name: 'ucrHomicideDetails',
      label: 'Homicide Details',
      array: [
        {
          name: 'victimAndIncidentReportId',
          label: 'Victim',
          validators: { required: true }
        },
        {
          name: 'victimIsOfficer',
          label: 'Officer',
          validators: {}
        },
        {
          name: 'offenderAndIncidentReportId',
          label: 'Offender',
          validators: { required: true }
        },
        {
          name: 'relationshipId',
          label: 'Relationship',
          validators: { required: true }
        },
        {
          name: 'ucrWeaponCodeId',
          label: 'Weapon',
          validators: { required: true }
        },
        {
          name: 'weaponIsAutomatic',
          label: 'Automatic',
          validators: {}
        },
        {
          name: 'ucrCircumstanceCodeId',
          label: 'Circumstance',
          validators: {}
        },
        {
          name: 'ucrSubCircumstanceCodeId',
          label: 'Sub-Circumstance',
          validators: {}
        },
      ]
    }
  ],
  customFields: []
}

const propertyPopoutForm = {
  fields: [
    {
      name: 'associatedOn',
      label: 'Link Date',
      validators: {}
    },
    {
      name: 'hasSequence',
      label: 'Set Sequence',
      validators: {}
    },
    {
      name: 'sequence',
      label: 'Sequence',
      validators: {}
    },
    {
      name: 'incidentIdToLink',
      label: 'Incident ID to Link',
      validators: {}
    },
    {
      name: 'comment',
      label: 'Comment',
      validators: {}
    },
    {
      name: 'isNibrsProperty',
      label: 'Is NIBRS Property',
      validators: {}
    },
    {
      name: 'propertyDescriptionId',
      label: 'Property Description',
      validators: {}
    },
    {
      name: 'nibrsOffenses',
      label: 'Associated NIBRS Offenses',
      array: [
        {
          name: 'violationId',
          label: 'NIBRS Offense',
          //validators: { required: true }
        },
        {
          name: 'lossTypeId',
          label: 'Loss Type',
          validators: {}
        },
        {
          name: 'amount',
          label: 'Value of Property',
          validators: {}
        },
        {
          name: 'recoveredOn',
          label: 'Date Recovered',
          validators: {}
        }
      ]
    },
    {
      name: 'drugTypeId',
      label: 'Suspected Drug Type',
      validators: {}
    },
    {
      name: 'drugQuantity',
      label: 'Estimated Drug Quantity',
      validators: {}
    },
    {
      name: 'drugMeasurementId',
      label: 'Drug Measurement',
      validators: {}
    },
    {
      name: 'over3Drugs',
      label: 'Over 3 Drugs',
      validators: {}
    },
    {
      name: 'numberOfStolenVehicles',
      label: '# of Stolen Vehicles',
      validators: {}
    },
    {
      name: 'numberOfRecoveredVehicles',
      label: '# of Recovered Vehicles',
      validators: {}
    },
    {
      name: 'nibrsPropertyDamages',
      label: 'Property Damages',
      array: [
        {
          name: 'entryPointId',
          label: 'Entry Point',
          //validators: { required: true }
        },
        {
          name: 'descriptionId',
          label: 'Description',
          //validators: { required: true }
        },
        {
          name: 'damageAmount',
          label: 'Damage Amount',
          validators: { }
        }
      ]
    },
    {
      name: 'firearmMakeId',
      label: 'Firearm Make',
      validators: {}
    },
    {
      name: 'firearmModel',
      label: 'Firearm Model',
      validators: {}
    },
    {
      name: 'firearmCaliber',
      label: 'Firearm Caliber',
      validators: {}
    },
    {
      name: 'firearmSerialNumber',
      label: 'Firearm Serial #',
      validators: {}
    },
    {
      name: 'isCarjacked',
      label: 'Carjacked',
      validators: {}
    },
    {
      name: 'nibrsCarjackingCodeIds',
      label: 'Carjacking Code(s)',
      validators: {}
    },
    {
      name: 'nicCode',
      label: 'NIC Code',
      validators: {}
    },
    {
      name: 'nibrsLicenseTypeId',
      label: 'License Type',
      validators: {}
    },
    {
      name: 'drugDataSourceId',
      label: 'Source of Drug',
      validators: {}
    },
    {
      name: 'propertyAndIncidentReportId',
      label: 'Property',
      //validators: { required: true }
    },
    {
      name: 'isUcrProperty',
      label: 'Is UCR Property',
      validators: {}
    },
    {
      name: 'ucrPropertyTypeId',
      label: 'Property Description',
      validators: {}
    },
    {
      name: 'stolenDate',
      label: 'Stolen Date',
      validators: {}
    },
    {
      name: 'stolenValue',
      label: 'Stolen Value',
      validators: {}
    },
    {
      name: 'stolenLocationCodeId',
      label: 'Stolen From',
      validators: {}
    },
    {
      name: 'recoverDate',
      label: 'Recovered Date',
      validators: {}
    },
    {
      name: 'recoveredValue',
      label: 'Recovered Value',
      validators: {}
    },
    {
      name: 'recoverLocationCodeId',
      label: 'Recovered From',
      validators: {}
    }
  ],
  customFields: []
}
const ucrPropertyPopoutForm = {
  fields: [
    {
      name: 'propertyAndIncidentReportId',
      label: 'Property',
      validators: { required: true }
    },
    {
      name: 'ucrPropertyTypeId',
      label: 'Property Description',
      validators: {}
    },
    {
      name: 'stolenDate',
      label: 'Stolen Date',
      validators: {}
    },
    {
      name: 'stolenValue',
      label: 'Stolen Value',
      validators: {}
    },
    {
      name: 'stolenLocationCodeId',
      label: 'Stolen From',
      validators: {}
    },
    {
      name: 'recoverDate',
      label: 'Recovered Date',
      validators: {}
    },
    {
      name: 'recoveredValue',
      label: 'Recovered Value',
      validators: {}
    },
    {
      name: 'recoverLocationCodeId',
      label: 'Recovered From',
      validators: {}
    }
  ],
  customFields: []
}

const ucrArresteePopoutForm = {
  fields: [
    {
      name: 'arrestReportId',
      label: 'Arrest Report',
      validators: { required: true }
    },
    {
      name: 'ucrCodeId',
      label: 'UCR Code',
      validators: {}
    },
    {
      name: 'ucrJuvenileDispositionId',
      label: 'UCR Juvenile Disposition',
      validators: {}
    },
    {
      name: 'ucrPartCOptionId',
      label: 'Part C Option',
      validators: {}
    },
    {
      name: 'ucrVerdictId',
      label: 'Verdict',
      validators: {}
    },
    {
      name: 'sentenceDate',
      label: 'Sentence Date',
      validators: {}
    }
  ],
  customFields: []
}

const cleryPrimaryInfoForm = {
  fields: [
    {
      name: 'occurredFrom',
      label: 'Incident Date/Time Start',
      validators: {},
    },
    {
      name: 'occurredTo',
      label: 'Incident Date/Time End',
      validators: {},
    },
    {
      name: 'cleryHateBiasId',
      label: 'Hate/Bias Type',
      validators: {}
    },
    {
      name: 'cleryOffenseDetails',
      label: 'Clery Offenses/Counts',
      array: [
        {
          name: 'cleryOffenseTypeId',
          label: 'Offense Type',
          validators: { required: true }
        },
        {
          name: 'cleryOffenseCount',
          label: 'Offense Count',
          validators: { required: true }
        }
      ]
    },
    {
      name: 'fireCategoryId',
      label: 'Fire Category',
      validators: {}
    },
    {
      name: 'fireCauseId',
      label: 'Cause of Fire',
      validators: {}
    },
    {
      name: 'fireLossValueId',
      label: 'Loss Value',
      validators: {}
    },
    {
      name: 'numberOfInjuries',
      label: '# of Injuries',
      validators: {}
    },
    {
      name: 'numberOfDeaths',
      label: '# of Deaths',
      validators: {}
    },
    {
      name: 'fireLogCommentText',
      label: 'Comment',
      validators: {}
    },
    {
      name: 'timelyWarningTypeId',
      label: 'Warning Notification Method',
      validators: {}
    },
    {
      name: 'timelyWarningNotifiedOn',
      label: 'Notification Date/Time',
      validators: {}
    },
    {
      name: 'dispositionTypeId',
      label: 'Disposition',
      validators: {}
    },
    {
      name: 'dispositionDate',
      label: 'Disposition Date',
      validators: {}
    },
    {
      name: 'dispositionCommentText',
      label: 'Comment',
      validators: {}
    }
  ],
  customFields: []
}

const cleryPersonPopoutForm = {
  fields : [
    {
      name: 'associatedOn',
      label: 'Link Date',
      validators: {}
    },
    {
      name: 'cleryPersonTypeId',
      label: 'Involvement',
      validators: { required: true }
    },
    {
      name: 'cleryDisciplineTypeId',
      label: 'Clery Discipline Type',
      validators: {}
    },
    {
      name: 'disciplinedOn',
      label: 'Clery Discipline Date',
      validators: {}
    },
    {
      name: 'notifiedOn',
      label: 'Campus Security Notified On',
      validators: {}
    },
    {
      name: 'commentText',
      label: 'Comment',
      validators: {}
    },
  ],
  customFields: []
}

const cleryLocationPopoutForm = {
  fields: [
    {
      name: 'cleryLocationAssociationTypeIds',
      label: 'Involvement',
      validators: {}
    },
    {
      name: 'isPrimary',
      label: 'Primary',
      validators: {}
    },
    {
      name: 'incidentAndAddressId',
      label: 'incidentAndAddressId',
      validators: {}
    },
    {
      name: 'cleryGeographyId',
      label: 'Clery Geography',
      validators: {}
    }
  ],
  customFields: [],
}

const cleryArrestPopoutForm = {
  fields : [
    {
      name: 'associatedOn',
      label: 'Link Date',
      validators: {}
    },
    {
      name: 'cleryArrestTypeId',
      label: 'Clery Arrest Type',
      validators: {}
    },
    {
      name: 'commentText',
      label: 'Comment',
      validators: {}
    }
  ],
  customFields: []
}

const trafficStopPrimaryInfoForm = {
  fields: [
    {
      name: 'trafficStopReasonIds',
      label: 'Traffic Stop Reason',
      validators: {}
    },
    {
      name: 'trafficStopReasonDescription',
      label: 'Other Reason Description',
      validators: { maxLength: 70 }
    },
    {
      name: 'isArrestMade',
      label: 'Arrest Made',
      validators: {}
    },
    {
      name: 'citationCount',
      label: 'Number of Citations',
      validators: {}
    },
    {
      name: 'warningCount',
      label: 'Number of Warnings',
      validators: {}
    },
    {
      name: 'isSearchConducted',
      label: 'Search Conducted',
      validators: {}
    },
    {
      name: 'trafficStopSearchedTypeIds',
      label: 'Searched',
      validators: {}
    },
    {
      name: 'trafficStopSearchReasonIds',
      label: 'Search Reason',
      validators: {}
    },
    {
      name: 'trafficStopPropertySeizedTypeIds',
      label: 'Property Seized',
      validators: {}
    }
  ],
  customFields: []
}

const trafficStopPersonPopoutForm = {
  fields : [
    {
      name: 'personAndIncidentReportId',
      label: 'Person',
      validators: { required: true }
    }
  ],
  customFields: []
}

export const incidentTagsFields = {
  fields: [...incidentTags.fields],
  customFields: [...incidentTags.customFields],
};

export const incidentPrimaryInformationFields = {
  fields: [...primaryInformation.fields],
  customFields: [...primaryInformation.customFields],
};

export const incidentPersonFields = {
  fields: [...persons.fields],
  customFields: [...persons.customFields]
}

export const incidentOrganizationFields = {
  fields: [...organizations.fields],
  customFields: [...organizations.customFields],
}

export const incidentDatesFields = {
  fields: [...dates.fields],
  customFields: [...dates.customFields],
};

export const incidentAssignmentsFields = {
  fields: [...assignments.fields],
  customFields: [...assignments.customFields],
};

export const incidentChargingFields = {
  fields: [...chargings.fields],
  customFields: [...chargings.customFields],
}

export const incidentProfessionalStandards = {
  fields: [...professionalStandards.fields],
  customFields: [...professionalStandards.customFields],
}

export const incidentModusOperandiFields = {
  fields: [...modusOperandis.fields],
  customFields: [...modusOperandis.customFields],
};

export const incidentLocationFields = {
  fields: [...location.fields],
  customFields: [...location.customFields],
};
export const incidentPersonAssociationFields = {
  fields: [...personAssociation.fields],
  customFields: [...personAssociation.customFields],
};

export const incidentReviewFields = {
  fields: [...incidentReview.fields],
  customFields: [...incidentReview.customFields]
}

export const incidentReviewersFields = {
  fields: [...incidentReviewers.fields],
  customFields: [...incidentReviewers.customFields]
}

export const incidentPropertyFields = {
  fields: [...propertyPopoutForm.fields],
  customFields: [...propertyPopoutForm.customFields],
}

export const supervisorFields = {
  fields: [...supervisor.fields],
  customFields: [...supervisor.customFields],
};

export const incidentUnitOfficerFields = {
  fields: [...unitOfficers.fields],
  customFields: [...unitOfficers.customFields]
}

export const nibrsPrimaryInformationFields = {
  fields: [...nibrsPrimaryInformation.fields],
  customFields: [...nibrsPrimaryInformation.customFields]
}

export const nibrsVictimPopoutFormFields = {
  fields: [...nibrsVictimPopoutForm.fields],
  customFields: [...nibrsVictimPopoutForm.customFields]
}

export const nibrsOffenderPopoutFormFields = {
  fields: [...nibrsOffenderPopoutForm.fields],
  customFields: [...nibrsOffenderPopoutForm.customFields]
}

export const nibrsOffensePopoutFormFields = {
  fields: [...nibrsOffensePopoutForm.fields],
  customFields: [...nibrsOffensePopoutForm.customFields]
}

export const nibrsPropertyPopoutFormFields = {
  fields: [...nibrsPropertyPopoutForm.fields],
  customFields: [...nibrsPropertyPopoutForm.customFields]
}

export const nibrsArresteePopoutFormFields = {
  fields: [...nibrsArresteePopoutForm.fields],
  customFields: [...nibrsArresteePopoutForm.customFields]
}

export const ucrPersonFields = {
  fields: [...ucrPersonsForm.fields],
  customFields: [...ucrPersonsForm.customFields]
}

export const ucrLeokaFields = {
  fields: [...ucrLeokaForm.fields],
  customFields: [...ucrLeokaForm.customFields]
}

export const ucrHomicideFields = {
  fields: [...ucrHomicideForm.fields],
  customFields: [...ucrHomicideForm.customFields]
}

export const ucrPropertyPopoutFormFields = {
  fields: [...ucrPropertyPopoutForm.fields],
  customFields: [...ucrPropertyPopoutForm.customFields]
}

export const ucrArresteePopoutFormFields = {
  fields: [...ucrArresteePopoutForm.fields],
  customFields: [...ucrArresteePopoutForm.customFields]
}

export const cleryPrimaryInfoFormFields = {
  fields: [...cleryPrimaryInfoForm.fields],
  customFields: [...cleryPrimaryInfoForm.customFields]
}

export const cleryPersonPopoutFormFields = {
  fields: [...cleryPersonPopoutForm.fields],
  customFields: [...cleryPersonPopoutForm.customFields]
}

export const cleryLocationPopoutFormFields = {
  fields: [...cleryLocationPopoutForm.fields],
  customFields: [...cleryLocationPopoutForm.customFields]
}

export const cleryArrestPopoutFormFields = {
  fields: [...cleryArrestPopoutForm.fields],
  customFields: [...cleryArrestPopoutForm.customFields]
}

export const trafficStopPrimaryInfoFormFields = {
  fields: [...trafficStopPrimaryInfoForm.fields],
  customFields: [...trafficStopPrimaryInfoForm.customFields]
}

export const trafficStopPersonPopoutFormFields = {
  fields: [...trafficStopPersonPopoutForm.fields],
  customFields: [...trafficStopPersonPopoutForm.customFields]
}